<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Fechas compras</h1>
                <div class="caption">
                    Muestra en color celeste la diferencia en días entre la necesidad del solicitante de la compra y
                    la fecha pactada por Pedido de compra y en color negro la diferencia en días entre la necesidad del
                    solicitante de la compra y la fecha de entrega real.
                    Permite seleccionar periodo a visualizar y empresa.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text class="text-xs-center">
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <v-switch label="Quitar intercompany" v-model="d.intercompany"></v-switch>
                        <v-menu
                                lazy
                                full-width
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(d.desde)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                full-width
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                :return-value.sync="menuHasta"
                                ref="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="hasta"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(d.hasta)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import monedaSelect from '../../components/MonedaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect, monedaSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    intercompany: false
                },
                datos: {},
                indeterminado: true,
                progresoPorcent: 0,
                progresoMsj: '',
                chartOptions:{
                    chart: {
                        type: 'column',
                        backgroundColor: '',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'FECHAS COMPRAS'
                    },
                    legend: {
                        enabled: true,
                    },
                    xAxis: {
                        type: 'category',
                        minRange: 1
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            }
                        }
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: <b>{point.y:,.2f} dias</b><br/>',
                    },
                    plotOptions: {
                        column: {
                            stacking: false,
                            grouping: true,
                            dataLabels: {
                                align: 'left',
                                rotation: -45,
                                enabled: true,
                                format: '{y:,.2f} dias'
                            }
                        },
                    },
                    series: self.datos
                }
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/fecha-compras', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        err(r)
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/fecha-compras.vue